import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/Home.vue'
import IntroduceView from '@/views/Introduce.vue'
import KnowsView from '@/views/Knows.vue'
import ProductsView from '@/views/Products.vue'
import ContactView from '@/views/Contact.vue'
import ProDetail from '@/views/ProDetail.vue'
import KnowDetail from '@/views/KnowDetail.vue'
import MobilesView from '@/views/Mobiles.vue'
Vue.use(VueRouter)

const routes = [
  { path: '/', component: HomeView },
  { path: '/product', component: ProductsView },
  { path: '/introduce', component: IntroduceView },
  { path: '/knows', component: KnowsView },
  { path: '/contact', component: ContactView },
  { path: '/prodetail/:id', component: ProDetail },
  { path: '/knowdetail/:id', component: KnowDetail },
  { path: '/mobiles', component: MobilesView }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 16 }
      }
    }
    return { x: 0, y: 0 }
  }
})

export default router
